import InputAdornment from '@material-ui/core/InputAdornment';
import CalendarIcon from '@material-ui/icons/CalendarToday';
import PropTypes from 'prop-types';
import React from 'react';
import Datetime from 'react-datetime';

import CustomInput from '../CustomInput/CustomInput';
import { useDateInputStyles } from './styles';

export const DateInput = ({
  labelText, defaultValue, onChange, validator, dateFormat,
}) => {
  const classes = useDateInputStyles();
  return (
    <Datetime
      className={classes.root}
      defaultValue={defaultValue}
      dateFormat={dateFormat}
      timeFormat={false}
      isValidDate={validator}
      onChange={onChange}
      renderInput={(dateInputProps, open, close) => (
        <CustomInput
          formControlProps={{ fullWidth: true }}
          inputProps={{
            ...dateInputProps,
            endAdornment: (
              <InputAdornment position="end">
                <CalendarIcon />
              </InputAdornment>
            ),
            disabled: true,
          }}
          onBlur={close}
          onFocus={open}
          labelText={labelText}
        />
      )}
    />
  );
};

DateInput.propTypes = {
  labelText   : PropTypes.string.isRequired,
  defaultValue: PropTypes.number,
  onChange    : PropTypes.func.isRequired,
  validator   : PropTypes.func.isRequired,
  dateFormat  : PropTypes.string,
};

DateInput.defaultProps = {
  defaultValue: undefined,
  dateFormat  : 'DD/MM/YYYY',
};
